<template>
	<div class="personal">
		<my-header></my-header>
	    
	    <div class="personal_main">
	    	<router-view v-wechat-title="system_web_name"></router-view>
	    </div>
	    
		<my-footer></my-footer>
		
		<div class="zhanyi" v-if="power && yiqing_img != ''">
			<!--<div class="zhanyi-title">
				<p>新冠肺炎密切接触者，国家版快速自查服务</p>
				<img src="../../../static/img/close-_pc.png" @click="power = false"/>
			</div>-->
			<img src="../../../static/img/close.png" @click="power = false"/>
			<!--<a href="#">-->
				<img :src="yiqing_img"/>
			<!--</a>-->
		</div>
	</div>
</template>

<script>
import header from "@/components/common/personalHeader";
import footer from "@/components/common/footer";
export default {
  name: "team",
  components: {
    "my-header": header,
    "my-footer": footer
  },
  data(){
  	return{
  		power:'',
  		system_web_name:'',
  		yiqing_img:''
  	}
  },
  mounted(){
  	const v = this;
	v.axios({
		method: 'get',
		url: '/api/yiqing/info',
		params: {
			p: "w"
		}
	})
	.then(function(res) {
		v.system_web_name = res.data.data.system_web_name;
		v.power = res.data.data.power;
		v.yiqing_img = res.data.data.yiqing_img;
		sessionStorage.setItem('system_web_name',v.system_web_name);
		sessionStorage.setItem('is_nouser_version',res.data.data.is_nouser_version);
		sessionStorage.setItem('power',res.data.data.power);
		sessionStorage.setItem('is_haveteam_version',res.data.data.is_haveteam_version);
		v.$store.commit("updateIsNouserVersion");
		v.$store.commit("updateSystemWebName");
		v.$store.commit("isHaveteamVersion");
	});
	v.axios({
		method: 'get',
		url: '/api/yiqing/text',
		params: {
			p: "w"
		}
	})
	.then(function(res) {
		sessionStorage.setItem('yiqing_text',JSON.stringify(res.data.data))
	});
  }
}
</script>

<style scoped lang="scss">
.personal{
	min-height: 100vh;
	margin: 0 auto;
	position: relative;
	padding-bottom: 166px;
	.personal_main{
		width: 1200px;
		min-height: 500px;
		margin: 0 auto;
	}
}





.zhanyi{
	width: 364px;
	position: fixed;
	top: calc(50vh - 107px);
	right: 1vw;
	background: #0F82BF;
	img{
		display: block;
		&:first-child{
			width: 20px;
			position: absolute;
			top: 10px;
			right: 10px;
			cursor: pointer;
		}
		&:last-child{
			width: 364px;
		}
	}
	/*a{
		display: block;
		width: 364px;
		img{
			display: block;
			width: 364px;
		}
	}*/
}
.zhanyi-title{
	color: #fff;
	font-size: 16px;
	line-height: 47px;
	height: 47px;
	padding-left: 14px;
	p{
		float: left;
	}
	img{
		width: 16px;
		float: right;
		margin: 16px 16px 16px 0;
		cursor: pointer;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/personal/home.vue